
const firebaseConfig = {
  apiKey: "AIzaSyBY9lnJVgpU3jBebPQb-BZoQ4076pf0sJY",
  authDomain: "staffy-8f0ed.firebaseapp.com",
  databaseURL: "https://staffy-8f0ed.firebaseio.com",
  projectId: "staffy-8f0ed",
  storageBucket: "staffy-8f0ed.appspot.com",
  messagingSenderId: "423542432527",
  appId: "1:423542432527:web:1348c7b8f98a0232ff547a",
  measurementId: "G-ZKKBBP23S9"
};

export const environment = {
  production: true,
  name: 'Production',

  API_BASE_URL: 'https://backend.salus.staffy.com',
  API_BASE_URL_COMPANIES: 'https://backend.salus.staffy.com',

  APPFLOW_CHANNEL: 'Production',
  SENTRY_RELEASE: 'testing',

  // White-label feature flags
  WHITE_LABEL: true,
  PAYMENTS_ENABLED: false,
  CREDENTIALS_ENABLED: false,
  GEO_FEATURES: false,
  SINGLE_CLIENT_MODE: true,

  // Branding
  APP_NAME: 'CBI Health',
  PRIMARY_COLOR: '#01a0e1',
  SECONDARY_COLOR: '#4dc4eb',

  // Stripe & Intercom disabled for white-label
  STRIPE_API_KEY: '',
  INTERCOM_KEY: '',

  firebase: firebaseConfig
};